import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9b0aeb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: `customerdictionary-types-modal`,
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": `customerdictionary-types-modal-title`,
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-xl",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: `customerdictionary-types-modal-title`
  }, " Dictionary Types "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_5 = { class: "table w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "System Name"),
    /*#__PURE__*/_createElementVNode("th", { width: "60" })
  ])
], -1))
const _hoisted_7 = { class: "table-primary" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "fixed-height" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value", "onBlur"]
const _hoisted_14 = ["value", "onBlur", "placeholder"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

import { ref, onMounted, computed, inject } from 'vue';
import { useStore } from 'vuex';
import _ from 'lodash';
import { DictionaryType } from '@/models';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDictionaryTypesModal',
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');
const newType = ref(new DictionaryType());
const currentTypesSorted = computed(() => store.getters['customerdictionary/currentTypesSorted']);

const addType = (type: DictionaryType): Promise<any> => {
  return store.dispatch('customerdictionary/addType', type);
};

const updateType = (type: DictionaryType): Promise<any> => {
  return store.dispatch('customerdictionary/updateType', type);
};

const setActiveType = (type: DictionaryType): void => {
  store.commit('customerdictionary/setActiveType', type);
};

const removeType = (type: DictionaryType): Promise<any> => {
  return store.dispatch('customerdictionary/removeType', type);
};

// Created lifecycle hook
onMounted(() => {
  reset();
});

// Reset Dictionary Type
const reset = () => {
  newType.value = new DictionaryType();
};

const add = () => {
  newType.value.slug = _.snakeCase(newType.value.getSystemName());
  addType(newType.value)
    .then(() => setActiveType(newType.value))
    .then(() => useToast().success(`Added "${newType.value.name}"`))
    .then(() => reset())
    .catch((err: any) => actProperty.displayError(err));
};

const updateName = ($event: any, type: DictionaryType) => {
  type.name = $event.target.value;
  updateType(type).catch((err: any) => actProperty.displayError(err));
};

const updateSystemName = ($event: any, type: DictionaryType) => {
  type.systemName = $event.target.value;
  updateType(type).catch((err: any) => actProperty.displayError(err));
};

const remove = (type: DictionaryType) => {
  actProperty.confirmPrompt()
    .then(() => removeType(type))
    .then(() => useToast().success(`Removed "${type.name}"`))
    .then(() => reset())
    .catch((err: any) => actProperty.displayError(err));
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newType.value.slug) = $event)),
                  placeholder: "Auto-generated",
                  readonly: "",
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, newType.value.slug]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  onKeyup: _withKeys(add, ["enter"]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newType.value.name) = $event)),
                  placeholder: "Required",
                  autocomplete: "off"
                }, null, 544), [
                  [_vModelText, newType.value.name]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  onKeyup: _withKeys(add, ["enter"]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newType.value.systemName) = $event)),
                  placeholder: "Optional",
                  autocomplete: "off"
                }, null, 544), [
                  [_vModelText, newType.value.systemName]
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: add,
                  disabled: !newType.value.name
                }, _hoisted_10, 8, _hoisted_8)
              ])
            ])
          ]),
          _createElementVNode("tbody", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTypesSorted.value, (type) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: type.slug
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    class: "form-control",
                    value: type.slug,
                    readonly: "",
                    autocomplete: "off"
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    class: "form-control",
                    value: type.name,
                    onBlur: ($event: any) => (updateName($event, type)),
                    autocomplete: "off"
                  }, null, 40, _hoisted_13)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    class: "form-control",
                    value: type.systemName,
                    onBlur: ($event: any) => (updateSystemName($event, type)),
                    placeholder: type.name,
                    autocomplete: "off"
                  }, null, 40, _hoisted_14)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger",
                    onClick: ($event: any) => (remove(type))
                  }, _hoisted_17, 8, _hoisted_15)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})